import CrudCustom from '../../../libs/custom/CrudCustom';

let PengaturanPemotonganPPhService = new CrudCustom('/tipe-pengurang-ph-brutos');
export default PengaturanPemotonganPPhService;
